import { Box } from "@mui/material";

import { useSubscriptionInfoList } from "fond/settings/AccountManagement/useSubscriptionInfoList";
import { Subscription } from "fond/types";
import { AgGrid } from "fond/widgets";

interface SubscriptionInfoListProps {
  subscriptions: Subscription[] | undefined;
}

const SubscriptionInfoList: React.FC<SubscriptionInfoListProps> = ({ subscriptions }: SubscriptionInfoListProps) => {
  const { columns, gridOptions } = useSubscriptionInfoList();

  return (
    <Box flexGrow={1} data-testid="subscription-info-list" mb={3}>
      <AgGrid columnDefs={columns} rowData={subscriptions ?? null} gridOptions={gridOptions} variant="outlined" />
    </Box>
  );
};

export default SubscriptionInfoList;
